import { useRef, useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'

const TripNotes = ({trip}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [tripNotes, setTripNotes] = useState(trip.trip_notes) //provided by trip argument which is from currentTripContext in currentTripDetails.js 
    const [error, setError] = useState(null)
    const [status, setStatus] = useState(null)
    const [disableCheck, setDisableCheck] = useState(false)
    const timeoutRef = useRef(null)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (disableCheck) return
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
        setStatus('loading')
        setDisableCheck(true)
        if (!user) {
            setStatus(null)
            setDisableCheck(false)
            setError('Not Authenticated')
            return
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip/notes/` , {
            method: 'PATCH',
            body: JSON.stringify({_id: trip._id, trip_notes: tripNotes}),
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        const json = await response.json() //response.json in a delete request is the document that was just deleted
        
        if (!response.ok) {
            setStatus(null)
            setDisableCheck(false)
            setError(json.error)
        }

        if (response.ok) {
            setError(null)
            console.log('Trip Notes Updated')
            dispatch({type: 'SET_TRIP', payload: json})
            setStatus('success')
            setDisableCheck(false)
            timeoutRef.current = setTimeout(() => {
                setStatus(null)
                timeoutRef.current = null
            }, 3000)
        }
    }   

    return (
        <form className="trip-notes" onSubmit={handleSubmit}>
            <label>Notes:</label>
            <textarea 
                onChange={(e) => setTripNotes(e.target.value)}
                value={tripNotes}
                className="notes-input">
            </textarea>
            <button disabled={disableCheck}>Save</button>
            {status === 'loading' && <span className="loading">Saving...</span>}
            {status === 'success' && <span className="save-success">Save Successful</span>}
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default TripNotes